import { useState } from 'react';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import { StaticVideo } from '@/types/video.types';
import Pill from '@ui/pill/pill';
import { formatMsToHHMMSS } from '@/utils/dates';

type TSessionVodRecordedInfoProps = {
  sessionVideo: StaticVideo;
  isEditMode?: boolean;
  onReset?: () => void;
};

const SessionVodRecordedInfo = ({ sessionVideo, isEditMode = false, onReset }: TSessionVodRecordedInfoProps) => {
  const [thumbnailError, setThumbnailError] = useState(false);
  const hasThumbnail = !thumbnailError && !!sessionVideo?.thumbnail_url?.trim();

  if (isEditMode) {
    return (
      <Container
        className="flex ai-center gap-12"
        height="84px"
        width="100%"
        design="GlobalCont1"
        padding="12px"
        borderRadius="8px"
      >
        <Container className="flex-column ai-center jc-center gap-4" borderRadius="8px" height="84px" width="100%">
          <Container className="flex ai-center jc-space-between padding-h-8" width="100%">
            <Text className="L2" design="GlobalIcoText3">
              Uploaded Video
            </Text>
            <Container className="flex ai-center gap-12">
              <Button padding="0" onClick={onReset}>
                <Text className="S2" color={getThemeColorCSSVariable(EColorVariablesV2.primary)}>
                  Reset
                </Text>
              </Button>
              {/* TODO: implement add thumbnail
              <Text className='L2' color="var(--global-cont-3)">|</Text>
              <Button padding='0' onClick={() => {}}>
                <Text className="S2" color={getThemeColorCSSVariable(EColorVariablesV2.primary)}>
                  Add thumbnail
                </Text>
              </Button>
              */}
            </Container>
          </Container>
          <Container
            className="flex ai-center gap-12"
            borderRadius="8px"
            padding="8px"
            design="GlobalCont2"
            width="100%"
            height="40px"
          >
            <Container className="flex ai-center jc-center gap-12" width="48px">
              {hasThumbnail ? (
                <img
                  src={sessionVideo?.thumbnail_url}
                  style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: '8px' }}
                  onError={() => setThumbnailError(true)}
                />
              ) : (
                <Container
                  height="32px"
                  width="100%"
                  borderRadius="8px"
                  border="2px dashed var(--gray-600)"
                  design="GlobalCont2"
                />
              )}
            </Container>
            <Text className="S2 flex-1" clamp={2}>
              {sessionVideo?.name}
            </Text>
            <Container className="flex ai-center gap-4">
              <Pill>
                <Text className="L2" design="GlobalIcoText1">
                  {formatMsToHHMMSS(sessionVideo?.duration_ms)}
                </Text>
              </Pill>
              {/* TODO: The following pill will need it's value to be the actual file type  */}
              <Pill backgroundColor="#00A3E9" padding="4px 8px">
                <Text className="L2" design="GlobalIcoText1">
                  MP4
                </Text>
              </Pill>
            </Container>
          </Container>
        </Container>
      </Container>
    );
  }

  return (
    <Container className="flex ai-center jc-flex-start" borderRadius="8px" padding="12px" height="84px" width="100%">
      <Container className="flex ai-center jc-center gap-12" height="100%" width="100px">
        {hasThumbnail ? (
          <img
            src={sessionVideo?.thumbnail_url}
            style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: '8px' }}
            onError={() => setThumbnailError(true)}
          />
        ) : (
          <Container
            height="100%"
            width="100%"
            borderRadius="8px"
            border="2px dashed var(--gray-600)"
            design="GlobalCont2"
          />
        )}
      </Container>
      <Container className="flex-column" borderRadius="8px" padding="8px" width="100%">
        <Text className="S3" clamp={2}>
          {sessionVideo?.name}
        </Text>
        <Text className="C1" design="GlobalIcoText3">
          Runtime: {formatMsToHHMMSS(sessionVideo?.duration_ms)}
        </Text>
      </Container>
    </Container>
  );
};

export default SessionVodRecordedInfo;
